import { createContext, useContext } from "react";

export const WelshContext = createContext(false);

const useWelsh = () => {
  return useContext(WelshContext);
};

export const useWelshMap = ({ english, welsh }) => {
  // const isWelsh = useWelsh();
  // return isWelsh ? welsh : english;
  return english;
};

export default useWelsh;
